import { FC, Fragment } from "react";
import { useTranslation } from "react-i18next";

import { IProductionSummaryItem } from "@ryde/shared";

import { ProductionPreviewSummaryStyled } from "../components";

interface IProductionPreviewDetailsSummaryItems {
  summaryItems: IProductionSummaryItem[] | undefined;
}

export const ProductionPreviewDetailsSummaryItems: FC<
  IProductionPreviewDetailsSummaryItems
> = ({ summaryItems }) => {
  const { t } = useTranslation();

  if (!summaryItems?.length) {
    return null;
  }

  return (
    <ProductionPreviewSummaryStyled>
      {summaryItems.map(item => (
        <Fragment key={item.label}>
          <div className="summary_item_title">{t(item.label)}</div>
          <div className="summary_item_info">{item.value}</div>
        </Fragment>
      ))}
    </ProductionPreviewSummaryStyled>
  );
};
